import React, {useEffect, useState} from 'react';
import {forcePdvSalePrinting} from "../../utils/requestUtils";
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import {formatDateTimeString} from "../../utils/utils";
import {showConfirm} from "../../core/dialog";

const apiUrl = Config.apiUrl;

const PdvSaleManagerSeeItems = ({sale, onClose, onRemove, isAdmin}) => {
    const [totalValue, setTotalValue] = useState(0);

    useEffect(() => {
        const handleBackButton = (e) => { e.preventDefault(); onClose(); };
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handleBackButton);
        const total = sale.saleItems.reduce((acc, item) => acc + (item.total || 0), 0);
        setTotalValue(total);
        return () => window.removeEventListener('popstate', handleBackButton);
    }, []);

    async function removeSale() {
        if (!await showConfirm('Essa operação não poderá ser revertida. Deseja continuar?')) return;
        try {
            await makeRequest(apiUrl + '/api/pdv-sales/' + sale.id, 'DELETE');
            onClose();
            onRemove();
        } catch (error) {
            console.error('Error:', error);
        }
    }

    return (
        <>
            <div className="header-label">Pedido: {sale.id}</div>
            <div>Data: {formatDateTimeString(sale.saleDate)}</div>
            <div>{sale.customer ? sale.customer.name : sale.customerName}</div>
            {sale.table && <div>{sale.table.name}</div>}
            {(sale.user || sale.userName) && <div>Garçom/Atendente: {sale.user?.name || sale.userName}</div>}
            <table style={{width: '100%'}}>
                <colgroup>
                    <col style={{width: '500px'}}/>
                    <col style={{width: '50px'}}/>
                    <col style={{width: '50px'}}/>
                </colgroup>
                <thead>
                <tr>
                    <th>Nome</th>
                    <th>Qtd</th>
                    <th>Preço</th>
                </tr>
                </thead>
                <tbody>
                {sale.saleItems.map((item, index) => (
                    <tr key={index} style={{backgroundColor: item.quantity > 0 ? 'var(--warning-color)' : item.quantity < 0 ? 'var(--error-color)' : 'white'}}>
                        <td><div>{item.productName}</div></td>
                        <td>{item.quantity || 0}</td>
                        <td><div style={{textAlign: 'right'}}>{(item.product?.salePrice || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</div></td>
                    </tr>
                ))}
                </tbody>
                {sale.saleItems.length === 0 && <tfoot><tr><td colSpan={3}>Nenhum item encontrado</td></tr></tfoot>}
            </table>
            <div style={{marginTop: '5px'}}>
                <div className="total-label" style={{textAlign: 'right', fontSize: '30px', color: '#cc5545'}}>
                    Valor Total: R$ {totalValue.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </div>
            </div>
            <ActionButtonsManagerView>
                <button onClick={onClose} className="back-button">Voltar</button>
                <button onClick={async () => { await forcePdvSalePrinting([sale.id]); }}>Reimprimir</button>
                {isAdmin && <button onClick={removeSale} className="remove-button">Excluir</button>}
            </ActionButtonsManagerView>
        </>
    );
};

export default PdvSaleManagerSeeItems;
